import React from 'react';
import { MediaRow, RowItem } from './media-row';
import { TitleCard } from './title-card';

export function TopTenRow({ titles = [] }) {
  if (!titles || titles.length === 0) return null;

  return (
    <MediaRow
      heading="Top 10 this week"
      note="What Kast members are watching"
      href="/browse?sort=popular"
    >
      {titles.slice(0, 10).map((title, index) => (
        <RowItem key={title.id || title.Id || index} variant="ranked">
          <TitleCard title={title} rank={index + 1} />
        </RowItem>
      ))}
    </MediaRow>
  );
}

export default TopTenRow;
